import { inject, Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { LoaderService } from "@shared/services/loader/loader.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private readonly loaderService = inject(LoaderService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (
            !req.url.includes("connect/token") &&
            !req.url.includes("/client-assertion") &&
            !req.url.includes("/appointments") &&
            !req.url.includes("/cards/details") &&
            !req.url.includes("/encounters/lookup") &&
            !req.url.includes("/patients/lookup") &&
            !(/\/api\/encounters\/\d+\/events\/\w+/.test(req.url) && req.method === "GET") &&
            !(/\/api\/searches\/\d+\/result(\?.*)?$/.test(req.url) && req.method === "POST") &&
            !(/\/api\/searches\/\d+\/usage(\?.*)?$/.test(req.url) && req.method === "POST") &&
            !(/\/api\/charts\/\d+$/.test(req.url) && req.method === "GET") &&
            !(/\/api\/charts\/\d+\/section-data(\?.*)?$/.test(req.url) && req.method === "GET")
        ) {
            this.loaderService.showLoader();
            return next.handle(req).pipe(finalize(() => this.loaderService.hideLoader()));
        } else {
            return next.handle(req);
        }
    }
}
